export default "__VITE_ASSET__DjlNkYQM__"